import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitPipe'
})
export class SplitPipePipe implements PipeTransform {

  transform(xval:any): any {
    let xvalor = xval.split('_');
    return xvalor[0].toUpperCase();
  }

}
